module.exports = __webpack_public_path__ + "71c016f9ec0652d133542469dddae0ec.png";